import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyStockBill from './pharmacy-stock-bill';
import PharmacyStockBillDetail from './pharmacy-stock-bill-detail';
import PharmacyStockBillUpdate from './pharmacy-stock-bill-update';
import PharmacyStockBillDeleteDialog from './pharmacy-stock-bill-delete-dialog';

const PharmacyStockBillRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyStockBill />} />
    <Route path="new" element={<PharmacyStockBillUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyStockBillDetail />} />
      <Route path="edit" element={<PharmacyStockBillUpdate />} />
      <Route path="delete" element={<PharmacyStockBillDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyStockBillRoutes;
